export default __webpack_public_path__ + "static/media/gtd5.8899aa84.jpg";